import { IconProps } from '@drift-labs/icons';
import { cj } from 'src/utils/classNames';

export default function Jupiter({
	className,
	color,
	size = 16,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				fill="none"
				viewBox="0 0 24 24"
			>
				<g clipPath="url(#a)">
					<path
						fill={color ?? 'currentColor'}
						d="M.072 13.409c-.028-.518-.081-.98-.07-1.43 0-.129.166-.293.294-.38a5.8 5.8 0 0 1 2.974-.854c3.198-.128 6.076.908 8.749 2.578a14.9 14.9 0 0 1 5.212 5.22 6.96 6.96 0 0 1 1.023 3.526.514.514 0 0 1-.32.55c-.38.165-.753.358-1.158.544-1.034-3.654-3.361-6.196-6.506-8.034S3.786 12.504.072 13.409m1.365-4.723a12.1 12.1 0 0 1 5.436.06 19.8 19.8 0 0 1 9.612 5.178 13.4 13.4 0 0 1 3.646 5.585c.134.418.227.855.355 1.284l.128.05c.236-.297.424-.63.554-.987a5.8 5.8 0 0 0 .064-1.87c-.249-1.62-1.109-2.96-2.132-4.202a20.5 20.5 0 0 0-7.558-5.667 15.95 15.95 0 0 0-6.85-1.591 6.2 6.2 0 0 0-3.06.715C.964 7.6.382 8.085.296 9.001c.42-.119.778-.219 1.14-.315m-.235 8.399a.58.58 0 0 0 .626.397 11.7 11.7 0 0 1 3.99.79 12.92 12.92 0 0 1 6.655 5.506.54.54 0 0 0 .409.222c.575-.047 1.148-.14 1.723-.211.252-.032.306-.182.245-.404-.035-.125-.067-.25-.11-.358-.735-2.216-2.167-3.904-3.994-5.277-2.348-1.763-4.974-2.832-7.934-2.79a23 23 0 0 0-2.377.28c.302.718.544 1.276.767 1.845M15.003 6.912c3.66 2.146 6.695 4.91 8.528 8.893a6.3 6.3 0 0 0-.032-1.788c-.355-1.724-1.308-3.14-2.448-4.42a21.44 21.44 0 0 0-10.305-6.396 11.5 11.5 0 0 0-5.504-.361 4.17 4.17 0 0 0-2.224 1.122c4.445-.479 8.333.812 11.985 2.95M9.076.476A24.75 24.75 0 0 1 24 9.218C22.05 1.896 14.538-1.265 9.076.462zM2.432 19.005c.924 2.117 5.937 5.063 8.357 4.891-1.71-2.76-5.547-4.827-8.357-4.891"
					/>
				</g>
				<defs>
					<clipPath id="a">
						<path fill="none" d="M0 0h24v24H0z" />
					</clipPath>
				</defs>
			</svg>
		</span>
	);
}
